import IListFilter from "@/models/IListFilter";
import {BillState, CompanyType} from "@/helpers/constants";
import {isEmpty} from "@/helpers/functions_asi";

export default class BillListFilter implements IListFilter {

	private static readonly defaultStateFilter = [];
	private readonly defaultStateFilterInternal: BillState[] = [];

	public fulltext: string | null = null;

	public states: BillState[] = [];
	public name: string | null = null;
	public number: string | null = null;
	public customerReference: string | null = null;
	public dateFrom: string | null = null;
	public dateTo: string | null = null;
	public companyName: string | null = null;
	public companyTypes: CompanyType[] = [];
	public isPaid: boolean | null = null;

	public constructor(defaultStateFilter: BillState[] | null = null) {
		this.defaultStateFilterInternal = defaultStateFilter === null ? BillListFilter.defaultStateFilter : defaultStateFilter;
		this.states = this.defaultStateFilterInternal;
	}

	public clear(): void {
		this.fulltext = null;
		this.states = this.defaultStateFilterInternal;
		this.name = null;
		this.number = null;
		this.customerReference = null;
		this.dateFrom = null;
		this.dateTo = null;
		this.companyName = null;
		this.companyTypes = [];
		this.isPaid = null;
	}

	public hasFilter(): boolean {
		if (this.states.length !== this.defaultStateFilterInternal.length) {
			return true;
		}

		for (let i = 0; i < this.states.length; i++) {
			if (!this.defaultStateFilterInternal.includes(this.states[i])) {
				return true;
			}
		}

		return !isEmpty(this.fulltext)
			|| !isEmpty(this.name)
			|| !isEmpty(this.number)
			|| !isEmpty(this.customerReference)
			|| !isEmpty(this.dateFrom)
			|| !isEmpty(this.dateTo)
			|| !isEmpty(this.companyName)
			|| this.companyTypes.length > 0
			|| this.isPaid !== null;
	}

}
